export const isValidCPF = (value = "") => {
  if (!value) return true;

  const cpf = value.replace(/[^\d]+/g, "");

  // Blacklist common values.
  const BLACKLIST = [
    "00000000000",
    "11111111111",
    "22222222222",
    "33333333333",
    "44444444444",
    "55555555555",
    "66666666666",
    "77777777777",
    "88888888888",
    "99999999999",
    "12345678909",
  ];

  if (cpf.length != 11 || BLACKLIST.includes(cpf)) return false;

  const sumFristDigit = function (
    cpf,
    position = 0,
    sum = 0,
  ) {
    if (position > 9) return 0;
    return (
      sum +
      sumFristDigit(
        cpf,
        position + 1,
        cpf[position] * (cpf.length - 1 - position),
      )
    );
  };

  const sumSecondDigit = function (
    cpf,
    position = 0,
    sum = 0,
  ) {
    if (position > 10) return 0;
    return (
      sum +
      sumSecondDigit(cpf, position + 1, cpf[position] * (cpf.length - position))
    );
  };

  function validaPrimeiroDigito(cpf = "") {
    let fDigit = (sumFristDigit(cpf) * 10) % 11;
    fDigit = fDigit == 10 || fDigit == 11 ? 0 : fDigit;
    if (String(fDigit) != cpf[9]) return false;
    return true;
  }

  function validaSegundoDigito(cpf = "") {
    let sDigit = (sumSecondDigit(cpf) * 10) % 11;
    sDigit = sDigit == 10 || sDigit == 11 ? 0 : sDigit;
    if (String(sDigit) != cpf[10]) return false;
    return true;
  }

  if (!validaPrimeiroDigito(cpf)) return false;
  if (!validaSegundoDigito(cpf)) return false;

  return true;
};

export const isValidCNPJ = (cnpj) => {
  cnpj = cnpj.replace(/[^\d]+/g,'');
 
  if(cnpj == '') return false;
   
  if (cnpj.length != 14)
      return false;

  // Elimina CNPJs invalidos conhecidos
  if (cnpj == "00000000000000" || 
      cnpj == "11111111111111" || 
      cnpj == "22222222222222" || 
      cnpj == "33333333333333" || 
      cnpj == "44444444444444" || 
      cnpj == "55555555555555" || 
      cnpj == "66666666666666" || 
      cnpj == "77777777777777" || 
      cnpj == "88888888888888" || 
      cnpj == "99999999999999")
      return false;
       
  // Valida DVs
  let tamanho = cnpj.length - 2
  let numeros = cnpj.substring(0,tamanho);
  let digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;
  let i;
  for (i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2)
          pos = 9;
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  if (resultado != digitos.charAt(0))
      return false;
       
  tamanho = tamanho + 1;
  numeros = cnpj.substring(0,tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2)
          pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  if (resultado != digitos.charAt(1))
        return false;
         
  return true;
};

export const isValidEmail = (value) => {
  const emailRegex = /^[^.]+[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;

  // * Valida regex do email
  return emailRegex.test(value);
};

export const isValidEan = (numero) => {
  let factor = 3;
  let sum = 0;
  let numlen = numero.length;

  if (numlen == 13) {
    for (let index = numero.length; index > 0; --index) {
      if (index != 13) {
        sum = sum + Number(numero.substring(index - 1, index)) * factor;
        factor = 4 - factor;
      }
    }
    let cc = (1000 - sum) % 10;
    let ca = Number(numero.substring(12));
    if (cc == ca) {
      return true;
    } else {
      return false;
    }
  }

  if (numlen == 14) {
    for (let index = numero.length; index > 0; --index) {
      if (index != 14) {
        sum = sum + Number(numero.substring(index - 1, index)) * factor;
        factor = 4 - factor;
      }
    }
    let cc = (1000 - sum) % 10;
    let ca = Number(numero.substring(13));
    if (cc == ca) {
      return true;
    } else {
      return false;
    }
  }

  if (numlen == 8) {
    for (let index = numero.length; index > 0; --index) {
      if (index != 8) {
        sum = sum + Number(numero.substring(index - 1, index)) * factor;
        factor = 4 - factor;
      }
    }
    let cc = (1000 - sum) % 10;
    let ca = Number(numero.substring(7));
    if (cc == ca) {
      return true;
    } else {
      return false;
    }
  }

  if (numlen == 12) {
    for (let index = numero.length; index > 0; --index) {
      if (index != 12) {
        sum = sum + Number(numero.substring(index - 1, index)) * factor;
        factor = 4 - factor;
      }
    }
    let cc = (1000 - sum) % 10;
    let ca = Number(numero.substring(11));
    if (cc == ca) {
      return true;
    } else {
      return false;
    }
  }

  if (numlen != 8 && numlen != 12 && numlen != 13 && numlen != 14) {
    return false;
  }

  return true;

  // const eanRegex = /^[0-9]{13}$/;

  // * Valida regex do ean
  // return value === "" || eanRegex.test(value);
};
